import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ResendEmailService } from "../../../services/auth.service";
import { StatusCodes } from "http-status-codes";
const VerifyAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    toast.success("Please check your register email to activate your account!");
  }, []);
  const handleResendEmail = async () => {
    const response = await ResendEmailService(location?.state?.email);
    if (response.status && response.status_code === StatusCodes.OK) {
      toast.success(response.message);
    } else {
      toast.error(response.message);
    }
  };
  return (
    <div className="flex justify-center items-center flex-col mt-4">
      <h1>Please verify your account</h1>
      <p>
        An email has been sent. Please click the link in your email to activate
        your account
      </p>
      <span
        onClick={handleResendEmail}
        className="underline text-blue-500 cursor-pointer"
      >
        resend email
      </span>
      <span
        onClick={() => navigate("/signup")}
        className="underline text-blue-500 cursor-pointer"
      >
        cancel
      </span>
    </div>
  );
};

export default VerifyAccount;
